module.exports = __webpack_public_path__ + "static/img/1.b2efb87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/Resistance/1.jpg
// module id = LQlw
// module chunks = 1